import type { DesignerNode, GetPlaceholderManifest, NodeSelector } from "../../types/index.ts";
import type { CreateNode, CreatePlaceholderData } from "./shared.ts";

export type CreatePlaceholderDesignerNode<T> = (selector: NodeSelector) => T;

export const createPlaceholderCreate =
  (getPlaceholder: GetPlaceholderManifest, createNode: CreateNode): CreatePlaceholderDesignerNode<DesignerNode> =>
  (selector) => {
    const manifest = getPlaceholder(selector);
    return createNode(manifest.typeId, {});
  };

export const createPlaceholderDataCreate = createPlaceholderCreate as (
  ...args: Parameters<typeof createPlaceholderCreate>
) => CreatePlaceholderData;
